import React from 'react';
import {
  footerHeadFontBoldStyle,
  footerHeadFontStyle
} from '../../partnerStyles';
import { bindActionCreators } from 'redux';
import * as GlobalActions from '../../reducers/actions';
import { connect } from 'react-redux';

const OyoNearbyCategories = props => {
  let outDivStyle = {
    width: '33.33%',
    textAlign: 'center'
  };

  let inDivStyle = {
    top: '50%',
    position: 'relative',
    transform: 'translateY(-50%)'
  };

  return (
    <div
      style={{
        display: 'flex',
        height: '200px',
        marginBottom: '30px',
        borderTop: '#aaa solid 0.1px',
        borderBottom: '#aaa solid 0.1px'
      }}
    >
      <div style={outDivStyle}>
        <div style={inDivStyle}>
          <div style={footerHeadFontBoldStyle}>
            {props.globalData.universal_translations.footer_subheading_1}
          </div>
          <div style={footerHeadFontStyle}>
            {props.globalData.universal_translations.footer_subcontent_1}
          </div>
        </div>
      </div>
      <div style={outDivStyle}>
        <div style={inDivStyle}>
          <div style={footerHeadFontBoldStyle}>
            {props.globalData.universal_translations.footer_subheading_2}
          </div>
          <div style={footerHeadFontStyle}>
            {props.globalData.universal_translations.footer_subcontent_2}
          </div>
        </div>
      </div>
      <div style={outDivStyle}>
        <div style={inDivStyle}>
          <div style={footerHeadFontBoldStyle}>
            {props.globalData.universal_translations.footer_subheading_3}
          </div>
          <div style={footerHeadFontStyle}>
            {props.globalData.universal_translations.footer_subheading_3}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OyoNearbyCategories);
